var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "masthead masthead--inner" }, [
        _c("div", { staticClass: "in" }, [
          _c(
            "div",
            {
              staticClass: "masthead__slide",
              staticStyle: {
                background:
                  "url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat",
                width: "100%",
                display: "inline-block"
              }
            },
            [
              _c("div", { staticClass: "masthead__caption" }, [
                _c("h3", [
                  _vm._v("Success!"),
                  _c("br"),
                  _vm._v(
                    "Great news" +
                      _vm._s(_vm.quote ? " " + _vm.quote.user.name : "") +
                      ", we have found the following options for you…"
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.new_costs && _vm.new_costs[0],
              expression: "new_costs && new_costs[0]"
            }
          ],
          staticStyle: { "text-align": "center" }
        },
        [
          _c("div", { staticClass: "in container" }, [
            _vm.quote &&
            !_vm.quote.uses_franking_machine &&
            _vm.new_costs &&
            _vm.new_costs[0] &&
            _vm.yourPotentialSavingIs(_vm.results.new_costs[0])
              .postage_savings_over_term > 0
              ? _c("h4", { staticClass: "header-like-para" }, [
                  _vm._v("Your Potential Saving is "),
                  _c("span", {
                    staticStyle: { color: "#b50a78 !important" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.mnwp(
                          Math.abs(
                            _vm.yourPotentialSavingIs(_vm.results.new_costs[0])
                              .postage_savings_over_term
                          )
                        )
                      )
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.quote &&
            _vm.quote.uses_franking_machine &&
            _vm.new_costs &&
            _vm.new_costs[0] &&
            _vm.yourPotentialSavingIs(_vm.results.new_costs[0])
              .savings_over_term > 0
              ? _c("h4", { staticClass: "header-like-para" }, [
                  _vm._v("Your Potential Saving is "),
                  _c("span", {
                    staticStyle: { color: "#b50a78 !important" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.mnwp(
                          Math.abs(
                            _vm.yourPotentialSavingIs(_vm.results.new_costs[0])
                              .savings_over_term
                          )
                        )
                      )
                    }
                  })
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "benefits" }, [
        _c("div", { staticClass: "in container" }, [
          _c("div", { staticClass: "cmpreRslt" }, [
            _c(
              "div",
              {
                staticClass: "frmTitle",
                staticStyle: { "text-align": "left", "font-weight": "600" }
              },
              [
                _vm._v("\n          Tailor your requirements:\n          "),
                _vm.quote && _vm.quote.office_address
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn--plain",
                        staticStyle: { "font-size": "0.8em", float: "right" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.quote ? _vm.quote.office_address : "")
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "frmTitle" }, [
              _vm._v("\n          Desired manufacturer\n        ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mnfctrSlct",
                staticStyle: { "background-color": "#CCC" }
              },
              [
                _c("div", { staticClass: "formElem__block" }, [
                  _c("div", { staticClass: "inputElem" }, [
                    _c("ul", [
                      _c("li", { staticClass: "manufacturer-toggle" }, [
                        _c("input", {
                          attrs: { type: "checkbox", checked: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleManufacturer(2)
                            }
                          }
                        }),
                        _c("div"),
                        _c("img", {
                          attrs: { src: "/static/styles/mailkit/img/manu1.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "manufacturer-toggle" }, [
                        _c("input", {
                          attrs: { type: "checkbox", checked: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleManufacturer(3)
                            }
                          }
                        }),
                        _c("div"),
                        _c("img", {
                          attrs: { src: "/static/styles/mailkit/img/manu2.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "manufacturer-toggle" }, [
                        _c("input", {
                          attrs: { type: "checkbox", checked: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleManufacturer(4)
                            }
                          }
                        }),
                        _c("div"),
                        _c("img", {
                          attrs: { src: "/static/styles/mailkit/img/manu3.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "manufacturer-toggle" }, [
                        _c("input", {
                          attrs: { type: "checkbox", checked: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleManufacturer(5)
                            }
                          }
                        }),
                        _c("div"),
                        _c("img", {
                          attrs: { src: "/static/styles/mailkit/img/manu4.png" }
                        })
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "frmTitle" }, [
              _vm._v(
                "\n          Select your preferred investment options\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "prcheOptn",
                staticStyle: {
                  "padding-top": "0px",
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center"
                }
              },
              [
                _c("div", { staticClass: "sm:pb-0 frmInline" }, [
                  _c(
                    "label",
                    {
                      staticStyle: {
                        position: "relative",
                        "font-size": "1.4rem",
                        "line-height": "1.4",
                        color: "#363636",
                        top: "4px",
                        "margin-right": "15px"
                      }
                    },
                    [_vm._v("Purchase Option Required")]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Yes")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.additionalOptions.quote_confirmation,
                        expression: "additionalOptions.quote_confirmation"
                      }
                    ],
                    attrs: { type: "radio", name: "reqpurchse" },
                    domProps: {
                      value: true,
                      checked: _vm._q(
                        _vm.additionalOptions.quote_confirmation,
                        true
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.additionalOptions,
                          "quote_confirmation",
                          true
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("No")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.additionalOptions.quote_confirmation,
                        expression: "additionalOptions.quote_confirmation"
                      }
                    ],
                    attrs: { type: "radio", name: "reqpurchse" },
                    domProps: {
                      value: false,
                      checked: _vm._q(
                        _vm.additionalOptions.quote_confirmation,
                        false
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.additionalOptions,
                          "quote_confirmation",
                          false
                        )
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "sm:pt-0 lesetrmOptn" }, [
              _c(
                "div",
                {
                  staticClass: "frmInline leaseOptionDrops",
                  staticStyle: { "padding-top": "0" }
                },
                [
                  _c("div", [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.lease_option_1,
                              expression: "additionalOptions.lease_option_1"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "lease_option_1",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _vm.additionalOptions.lease_option_2 != 1
                            ? _c("option", { domProps: { value: 1 } }, [
                                _vm._v("1 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_2 != 2
                            ? _c("option", { domProps: { value: 2 } }, [
                                _vm._v("2 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_2 != 3
                            ? _c("option", { domProps: { value: 3 } }, [
                                _vm._v("3 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_2 != 4
                            ? _c("option", { domProps: { value: 4 } }, [
                                _vm._v("4 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_2 != 5
                            ? _c("option", { domProps: { value: 5 } }, [
                                _vm._v("5 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_2 != 6
                            ? _c("option", { domProps: { value: 6 } }, [
                                _vm._v("6 year")
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.lease_option_2,
                              expression: "additionalOptions.lease_option_2"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "lease_option_2",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _vm.additionalOptions.lease_option_1 != 1
                            ? _c("option", { domProps: { value: 1 } }, [
                                _vm._v("1 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_1 != 2
                            ? _c("option", { domProps: { value: 2 } }, [
                                _vm._v("2 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_1 != 3
                            ? _c("option", { domProps: { value: 3 } }, [
                                _vm._v("3 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_1 != 4
                            ? _c("option", { domProps: { value: 4 } }, [
                                _vm._v("4 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_1 != 5
                            ? _c("option", { domProps: { value: 5 } }, [
                                _vm._v("5 year")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.lease_option_1 != 6
                            ? _c("option", { domProps: { value: 6 } }, [
                                _vm._v("6 year")
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefTip" }, [
              _vm._v("Top tip: The longer the term the larger the savings")
            ]),
            _vm._v(" "),
            _vm.topModal
              ? _c("div", { staticClass: "benefits__forms formElem" }, [
                  _c("div", { staticClass: "inputmodal active" }, [
                    _c("div", { staticClass: "in" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("p", [
                        _vm.topModal == 1
                          ? _c("span", [
                              _vm._v(
                                "\n                  Manual Feed or Handfeed machines are the entry level franking machines allowing the user to feed and process one letter at a time through the feeder.\n                  An Automatic machine allows you to stack up same size and weight items on the feeder for the machine to very quickly process. The user confirms on the machine which postage service is required and the franking machine automatically processes the pile of post, franking all items at the same rate.\n                  Fully automatic machines have inline dimension and weighing capabilities allowing the user to stack mixed size and weight items on to the feeder, all the user does is confirm the postal class and the machine will very quickly check the length, width, thickness, depth and weight and frank each letter accordingly with the correct postage rate. This avoids errors, surcharges and prevents risk of embarrassment to clients who receive mail incorrectly processed and subsequently have to collect it from a postage office and often pay for the privilege.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 2
                          ? _c("span", [
                              _vm._v(
                                "\n                  Most franking machines come with the ability to add accounts, this allows you to process items under an account in the franking machine and later report on usage. This helps simplify the cross billing and charging to different departments or cost centres.\n                  "
                              ),
                              _c("b", [_vm._v("Important")]),
                              _vm._v(
                                " The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 3
                          ? _c("span", [
                              _vm._v(
                                "\n                  A typical letter weighs around 60g and because of this such we find most businesses only require a 2-3kg scale these days, however options up to 30/35kg still exist on Pitney Bowes and Quadient (Neopost) models.\n                  "
                              ),
                              _c("b", [_vm._v("Important")]),
                              _vm._v(
                                " Frama only offer linked scales up to 5kg so any weight beyond these will limit your result options to just Pitney Bowes, Quadient (Neopost) and FP.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 4
                          ? _c("span", [
                              _vm._v(
                                "\n                  Engineer installation and training allows for an onsite engineer to support on the setup, installation and training for the use of the new franking solution. Some machines come as standard with engineer installation and training, others are self-install unless you opt for the added service.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 5
                          ? _c("span", [
                              _vm._v(
                                "\n                  The differential weighing feature is a great feature for any business regularly sending a large number of packets/parcels. The operator can stack the items collectively on the scale, choose the appropriate class and under differential mode as an item is removed a label for the item can be printed and applied to that item, this process can then be repeated for all items on the scale speeding up the process of shipping.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 6
                          ? _c("span", [
                              _vm._v(
                                "\n                  Logo and return addresses are available on all machines, however only some provide these free of charge with the machine. Where a logo or return address isn't provided with the machine you have the option to add this at a cost.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 7
                          ? _c("span", [
                              _vm._v(
                                "\n                  Business Mail Advanced is a discounted mail tariff for businesses sending over 250 Letter format (DL/C5) items in any single mailing, discounts are based on items with clean addresses i.e. allowing Royal Mail to read and automatically sort/process mail without manual intervention and in doing so they pass on savings for this automation.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 8
                          ? _c("span", [
                              _vm._v(
                                "\n                  All new mailing machines require a network connection for updates, to transmit postage spend information and for postage top ups/refills. Some models offer the option of wifi connection, 3G connection (via a dongle) or PC meter connect (this utilises a PC with internet connection and some software to allow a connection.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 9
                          ? _c("span", [
                              _c("b", [_vm._v("Payment in arrears:")]),
                              _c("br"),
                              _vm._v(
                                "\n                  This service is only available through Pitney Bowes and Quadient (Neopost) at this time. This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account. Pitney Bowes payment in arrears service is called Purchase Power. Quadient (Neopost) is called Neofunds.\n                  "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(" "),
                              _c("b", [_vm._v("Payment in advance")]),
                              _c("br"),
                              _vm._v(
                                "\n                  The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account. For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 10
                          ? _c("span", [
                              _vm._v(
                                "\n                  This technology is only available from Pitney Bowes and provides the abilty to add a barcode scanner to the franking machine. This then allows the users to scan the barcode on items received, input the intended recipient, send an email notification to the recipient confirming an item has been received for them before the team print a delivery manifest on a connected printed (not supplied) and take to the recipient to sign on delivery. Future upgrade options are available to allow delivery and signature capture via WiFi or 3g connected PDAs.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 11
                          ? _c("span", [
                              _vm._v(
                                "\n                  This technology allows users to rate shop for recorded, special delivery 1pms and parcel/packets for shipping. The kit provides the license, a shipping label printer and 30kg scale for PC connection. A user can then save regular recipients they send to whilst also entering the email of the sender and recipient to provide tracking information automatically on posting.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.topModal == 12
                          ? _c("span", [
                              _vm._v(
                                "\n                  Quadient (Neopost) and FP (Francotyp Postalia) offer enhanced service maintenance options. Enhanced service options provide an expedited resolution to any machine issues vs the manufacturers standard service maintenance options. They come at a premium but if processing your post is critical to your business it is worth considering. A more appropriate consideration is often a small secondary device as this would offer true contingency at a low cost whilst supporting your business at peak times.\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "modelClose",
                            on: {
                              click: function($event) {
                                _vm.topModal = null
                              }
                            }
                          },
                          [_vm._v("(X)")]
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  "margin-bottom": "10px",
                  "padding-left": "10px",
                  width: "100%"
                }
              },
              [
                _c("div", { staticClass: "results-advanced-options-button" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.additionalOptionsOpen = !_vm.additionalOptionsOpen
                        }
                      }
                    },
                    [
                      _vm._v("\n            Advanced options\n            "),
                      !_vm.additionalOptionsOpen
                        ? _c("i", { staticClass: "fa fa-chevron-right" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.additionalOptionsOpen
                        ? _c("i", { staticClass: "fa fa-chevron-down" })
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "results-reset-options-button" }, [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.resetFilters()
                        }
                      }
                    },
                    [_vm._v("Reset Options")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } })
              ]
            ),
            _vm._v(" "),
            _vm.additionalOptionsOpen
              ? _c("div", { staticClass: "benefits__forms formElem" }, [
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 1
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v("\n              feeder type\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.feeder_type,
                              expression: "additionalOptions.feeder_type"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "feeder_type",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Please Select")]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "hand" } }, [
                            _vm._v("Hand feeder")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "auto" } }, [
                            _vm._v("Automatic feeder")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "full_auto" } }, [
                            _vm._v("Fully automatic feeder")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 2
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Departmental accounting\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.accounts_amount,
                              expression: "additionalOptions.accounts_amount"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "accounts_amount",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Please Select")]
                          ),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 9 } }, [
                            _vm._v("Up to 9")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 10 } }, [
                            _vm._v("Up to 10")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 25 } }, [
                            _vm._v("Up to 25")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 30 } }, [
                            _vm._v("Up to 30")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 35 } }, [
                            _vm._v("Up to 35")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 50 } }, [
                            _vm._v("Up to 50")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 100 } }, [
                            _vm._v("Up to 100")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 150 } }, [
                            _vm._v("Up to 150")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 200 } }, [
                            _vm._v("Up to 200")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 300 } }, [
                            _vm._v("Up to 300")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 500 } }, [
                            _vm._v("Up to 500")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1000 } }, [
                            _vm._v("Up to 1000")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2000 } }, [
                            _vm._v("Up to 2000")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 3000 } }, [
                            _vm._v("Up to 3000")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 3
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v("\n              scale size\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.packets_capacity,
                              expression: "additionalOptions.packets_capacity"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "packets_capacity",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Please Select")]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2_3" } }, [
                            _vm._v("2 - 3 KG")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "5" } }, [
                            _vm._v("5 KG")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "7" } }, [
                            _vm._v("7 KG")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "10_12" } }, [
                            _vm._v("10 - 12 KG")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "30_35" } }, [
                            _vm._v("30 - 35 KG")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 4
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v("\n              install & training\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.additionalOptions
                                  .engineer_installation_training,
                              expression:
                                "additionalOptions.engineer_installation_training"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "engineer_installation_training",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Please Select")]
                          ),
                          _vm._v(" "),
                          _c("option", { domProps: { value: "add" } }, [
                            _vm._v("Add")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Don't add")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 5
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Differential weighting\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.additionalOptions.differential_weighting,
                              expression:
                                "additionalOptions.differential_weighting"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "differential_weighting",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "add" } }, [
                            _vm._v("Add")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Don't add")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 6
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Custom Logo/Return Address Included with New Machine\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.additionalOptions.logo_and_return_address,
                              expression:
                                "additionalOptions.logo_and_return_address"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "logo_and_return_address",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "add" } }, [
                            _vm._v("Add")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Don't add")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 7
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Business mail advanced\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.additionalOptions.business_mail_advanced,
                              expression:
                                "additionalOptions.business_mail_advanced"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "business_mail_advanced",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "add" } }, [
                            _vm._v("Add")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Don't add")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 8
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Connectivity kit options\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.connectivity,
                              expression: "additionalOptions.connectivity"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "connectivity",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "3g" } }, [
                            _vm._v("3G")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "wifi" } }, [
                            _vm._v("Wi-Fi")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 9
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v("\n              Postage payment\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.additionalOptions.postage_payment,
                              expression: "additionalOptions.postage_payment"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "postage_payment",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "advanced" } }, [
                            _vm._v("Advance")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "arrears" } }, [
                            _vm._v("Arrears")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 10
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Barcode Scanner Peripherals\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputElem" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.additionalOptions
                                  .inbound_courier_parcel_tracking_cost,
                              expression:
                                "additionalOptions.inbound_courier_parcel_tracking_cost"
                            }
                          ],
                          staticClass: "option-select",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.additionalOptions,
                                "inbound_courier_parcel_tracking_cost",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Please select")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "add" } }, [
                            _vm._v("Add barcode scanner")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Don't add")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 11
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Outbound shipping application\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.additionalOptions
                                .outbound_shipping_application,
                            expression:
                              "additionalOptions.outbound_shipping_application"
                          }
                        ],
                        staticClass: "option-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.additionalOptions,
                              "outbound_shipping_application",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Please select")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "add" } }, [
                          _vm._v("Add")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("Don't add")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "formElem__block" }, [
                    _c("div", { staticClass: "inputLabel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "infoIcon",
                          on: {
                            click: function($event) {
                              _vm.topModal = 12
                            }
                          }
                        },
                        [_vm._v(" i ")]
                      ),
                      _vm._v(
                        "\n              Service / maintenance offering\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.additionalOptions.service_upgrade,
                            expression: "additionalOptions.service_upgrade"
                          }
                        ],
                        staticClass: "option-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.additionalOptions,
                              "service_upgrade",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Please select")
                        ]),
                        _vm._v(" "),
                        !(
                          _vm.quote.postage_payment === "arrears" &&
                          _vm.quote.postage_spend_custom > 10000
                        )
                          ? _c("option", { attrs: { value: "standard" } }, [
                              _vm._v("Standard")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "enhanced" } }, [
                          _vm._v("Enhanced")
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "results desktop" }, [
        _c("div", { staticClass: "in container" }, [
          _vm.new_costs
            ? _c(
                "div",
                {
                  staticClass: "results__table",
                  staticStyle: { overflow: "visible !important" }
                },
                [
                  _c("table", [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { staticClass: "noStyle" }),
                      _vm._v(" "),
                      _c("th", { staticClass: "large" }, [
                        _vm._v("Manufacturer and model")
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Speed (letters/minute)  ")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Envelope thickness capacity")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Scale capacity")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Service offering")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Product rating")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.quote.uses_franking_machine,
                              expression: "!quote.uses_franking_machine"
                            }
                          ]
                        },
                        [_vm._v("Best Quarterly Lease Option")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.quote.uses_franking_machine,
                              expression: "quote.uses_franking_machine"
                            }
                          ]
                        },
                        [_vm._v("Your potential savings")]
                      ),
                      _vm._v(" "),
                      _c("th", [_vm._v("Features explained")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _vm._m(4),
                          _vm._v(" "),
                          _c("td", { staticClass: "image" }, [
                            _vm.current_costs && _vm.current_costs.printer
                              ? _c("img", {
                                  class: {
                                    stamps: _vm.current_costs.printer.id == 1
                                  },
                                  attrs: {
                                    src: _vm.printerImage(
                                      _vm.current_costs.printer.image_url
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.current_costs &&
                                      _vm.current_costs.printer
                                      ? _vm.current_costs.printer.manufacturer
                                          .name
                                      : ""
                                  ) +
                                  "\n                "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.current_costs &&
                                      _vm.current_costs.printer
                                      ? _vm.current_costs.printer.model
                                      : ""
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "innerTable" }, [
                            _c("table", [
                              _c("tr", [
                                _c("td", [
                                  _c("h6", [_vm._v("Standard")]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.current_costs &&
                                          _vm.current_costs.printer
                                          ? _vm.current_costs.printer
                                              .speed_standard
                                          : 0
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _c("h6", [_vm._v("Auto size and weight")]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.current_costs &&
                                          _vm.current_costs.printer
                                          ? _vm.current_costs.printer
                                              .auto_size_weight
                                          : 0
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.current_costs && _vm.current_costs.printer
                                  ? _vm.current_costs.printer
                                      .envelope_thickness_capacity
                                  : 0
                              ) + " mm"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.current_costs && _vm.current_costs.printer
                                  ? _vm.current_costs.printer.scale_capacity
                                  : 0
                              ) + " kg"
                            )
                          ]),
                          _vm._v(" "),
                          _vm.current_costs &&
                          _vm.current_costs.printer &&
                          _vm.current_costs.printer.model === "Stamps"
                            ? _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "1.8rem",
                                    "font-weight": "400"
                                  }
                                },
                                [_vm._v("N/A")]
                              )
                            : _c("td", [_vm._v("AS PER EXISTING")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("rating-view", {
                                attrs: {
                                  rating: _vm.current_costs
                                    ? _vm.current_costs.rating
                                    : 0,
                                  max: _vm.results ? _vm.results.max_rating : 0
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "largeText",
                              staticStyle: {
                                "font-size": "1.8rem",
                                "font-weight": "400"
                              }
                            },
                            [_vm._v("N/A")]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "largeText",
                              staticStyle: {
                                "font-size": "1.8rem",
                                "font-weight": "400"
                              }
                            },
                            [_vm._v("N/A")]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._l(_vm.new_costs, function(costs, index) {
                          return _vm.new_costs &&
                            _vm.enabledManufacturers[costs.manufacturer.id] ===
                              true
                            ? _c(
                                "fragment",
                                { key: index },
                                [
                                  _vm.costsHasError(costs)
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "rotate grey",
                                            attrs: { t: "t1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !_vm.costsHasError(
                                                      costs
                                                    ),
                                                    expression:
                                                      "!costsHasError(costs)"
                                                  }
                                                ],
                                                staticStyle: {
                                                  "font-size": "25px"
                                                }
                                              },
                                              [_vm._v("Proposed")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "image" }, [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "/static/styles/mailkit/img/manu" +
                                                (costs.manufacturer.id - 1) +
                                                ".png"
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-transform": "none"
                                            },
                                            attrs: { colspan: "8" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "center"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/static/styles/mailkit/img/warning.png",
                                                    alt: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    { staticClass: "red-text" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          costs.manufacturer
                                                            .name
                                                        ) +
                                                          " option not available due to:"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !costs.feeder_type_not_found &&
                                                  costs.scale_cost_machine_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - " +
                                                              _vm._s(
                                                                _vm.additionalOptions.packets_capacity.replace(
                                                                  "_",
                                                                  " - "
                                                                )
                                                              ) +
                                                              "kg Scale size not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.departmental_accounting_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - " +
                                                              _vm._s(
                                                                _vm
                                                                  .additionalOptions
                                                                  .accounts_amount
                                                              ) +
                                                              " accounts not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.postage_payment_arrears_warning
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Arrears postage account not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.differential_weighting_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Differential weighting is not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.business_mail_advanced_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Business mail advanced is not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.connectivity_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - " +
                                                              _vm._s(
                                                                _vm
                                                                  .additionalOptions
                                                                  .connectivity
                                                              ) +
                                                              " connectivity option is not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.inbound_courier_parcel_tracking_cost_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Barcode scanner peripherals are not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.outbound_shipping_application_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Outbound shipping application is not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.service_upgrade_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - Service upgrade is not available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.comparable_model_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - No comparable model available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.feeder_type_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " - " +
                                                              _vm._s(
                                                                _vm.getReadableFeederType(
                                                                  _vm
                                                                    .additionalOptions
                                                                    .feeder_type
                                                                )
                                                              ) +
                                                              " not available;"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  costs.machine_not_found
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "red-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Can't find a machine that fits the requirements"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "blue-text" },
                                              [
                                                _vm._v(
                                                  "If your requirements are flexible, try tailoring your options to pull more results"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.costsHasError(costs)
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "rotate red",
                                            attrs: { rowspan: "1", t: "t2" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "25px"
                                                }
                                              },
                                              [_vm._v("Proposed")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "image",
                                            attrs: { rowspan: "1" }
                                          },
                                          [
                                            costs.printer
                                              ? _c("img", {
                                                  attrs: {
                                                    src: _vm.printerImage(
                                                      costs.printer.image_url
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  costs.printer
                                                    ? costs.printer.manufacturer
                                                        .name
                                                    : ""
                                                ) +
                                                "\n                "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  costs.printer
                                                    ? costs.printer.model
                                                    : ""
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "innerTable" },
                                          [
                                            _c("table", [
                                              _c("tr", [
                                                _c("td", [
                                                  _c("h6", [
                                                    _vm._v("Standard")
                                                  ]),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        costs.printer
                                                          ? costs.printer
                                                              .speed_standard
                                                          : 0
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      "Auto size and weight"
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        costs.printer
                                                          ? costs.printer
                                                              .auto_size_weight
                                                          : 0
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ])
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer
                                                ? costs.printer
                                                    .envelope_thickness_capacity
                                                : 0
                                            ) + " mm"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.additionalOptions.packets_capacity.replace(
                                                  "_",
                                                  "-"
                                                )
                                              ) +
                                              " kg\n              "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.quote.service_upgrade === "enhanced"
                                          ? _c("td", [
                                              costs.printer.manufacturer_id ===
                                              4
                                                ? _c("span", [
                                                    _vm._v("swapit+")
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              costs.printer.manufacturer_id ===
                                              3
                                                ? _c("span", [
                                                    _vm._v("total care")
                                                  ])
                                                : _vm._e()
                                            ])
                                          : costs.postage_recredit_costs_updated_to_total_care
                                          ? _c("td", [
                                              _vm._v(
                                                "\n                TOTAL CARE\n              "
                                              )
                                            ])
                                          : _c("td", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    costs.printer
                                                      ? costs.printer
                                                          .service_name
                                                      : "-"
                                                  ) +
                                                  "\n              "
                                              )
                                            ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c("rating-view", {
                                              attrs: {
                                                rating: costs.printer
                                                  ? costs.rating
                                                  : 0,
                                                max: _vm.results
                                                  ? _vm.results.max_rating
                                                  : 0
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "largeText red",
                                            staticStyle: {
                                              color: "#b50a78 !important"
                                            }
                                          },
                                          [
                                            _vm.quote.uses_franking_machine
                                              ? _c("span", {
                                                  staticStyle: {
                                                    "white-space": "nowrap",
                                                    "font-size": "1.8rem",
                                                    "font-weight": "400"
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      costs &&
                                                        _vm.yourPotentialSavingIs(
                                                          costs
                                                        ).savings_over_term > 0
                                                        ? _vm.mnwp(
                                                            Math.abs(
                                                              _vm.yourPotentialSavingIs(
                                                                costs
                                                              )
                                                                .savings_over_term
                                                            )
                                                          )
                                                        : "N/A"
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.quote.uses_franking_machine
                                              ? _c("span", {
                                                  staticStyle: {
                                                    "white-space": "nowrap",
                                                    "font-size": "1.8rem",
                                                    "font-weight": "400"
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      costs.costQuarterlyLease >
                                                        0
                                                        ? _vm.mnwp(
                                                            Math.abs(
                                                              costs.costQuarterlyLease
                                                            )
                                                          )
                                                        : "N/A"
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn btn-gradient",
                                              staticStyle: {
                                                border: "none",
                                                padding: "10px 20px",
                                                "border-radius": "10px"
                                              },
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleMoreInfo(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "700"
                                                  }
                                                },
                                                [_vm._v("View Quote Details")]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.costsHasError(costs) &&
                                  _vm.showMoreInfo === index &&
                                  costs.printer
                                    ? _c("more-info-tr", {
                                        attrs: {
                                          quote: _vm.quote,
                                          new_costs: costs,
                                          current_costs: _vm.current_costs,
                                          model: costs.printer,
                                          service_upgrade:
                                            _vm.additionalOptions
                                              .service_upgrade,
                                          quote_confirmation:
                                            _vm.additionalOptions
                                              .quote_confirmation,
                                          additionalOptions:
                                            _vm.additionalOptions
                                        },
                                        on: {
                                          "progress-with-order": function(
                                            investment_option
                                          ) {
                                            return _vm.onProgressWithOrder(
                                              investment_option,
                                              _vm.quote,
                                              costs,
                                              _vm.additionalOptions,
                                              _vm.current_costs
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", {
                                      staticStyle: {
                                        height: "10px",
                                        "background-color": "#F4F4F4"
                                      },
                                      attrs: { colspan: "9" }
                                    })
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.new_costs
        ? _c("section", { staticClass: "results-mobile" }, [
            _c(
              "div",
              { staticClass: "in container" },
              [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "offer first" }, [
                  _c("strong", { staticClass: "offer-title blue" }, [
                    _vm._v("Current Solution")
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "offer-table" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "image" }, [
                        _vm.current_costs && _vm.current_costs.printer
                          ? _c("img", {
                              class: {
                                stamps: _vm.current_costs.printer.id == 1
                              },
                              attrs: {
                                src: _vm.printerImage(
                                  _vm.current_costs.printer.image_url
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.current_costs && _vm.current_costs.printer
                                ? _vm.current_costs.printer.manufacturer.name
                                : ""
                            )
                        ),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.current_costs && _vm.current_costs.printer
                                ? _vm.current_costs.printer.model
                                : ""
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [_vm._v("standard")]),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.current_costs && _vm.current_costs.printer
                                ? _vm.current_costs.printer.speed_standard
                                : 0
                            ) +
                            "\n\n              "
                        ),
                        _c("div", { staticClass: "separator" }),
                        _vm._v(" "),
                        _vm._m(8),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.current_costs && _vm.current_costs.printer
                                ? _vm.current_costs.printer.auto_size_weight
                                : 0
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.current_costs && _vm.current_costs.printer
                              ? _vm.current_costs.printer
                                  .envelope_thickness_capacity
                              : 0
                          ) + " mm"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.current_costs && _vm.current_costs.printer
                              ? _vm.current_costs.printer.scale_capacity
                              : 0
                          ) + " kg"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.current_costs && _vm.current_costs.printer
                                ? _vm.current_costs.printer.service_name
                                : "-"
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("rating-view", {
                            attrs: {
                              rating: _vm.current_costs
                                ? _vm.current_costs.rating
                                : 0,
                              max: _vm.results ? _vm.results.max_rating : 0
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "largeText",
                          staticStyle: {
                            "font-size": "1.8rem",
                            "font-weight": "400"
                          }
                        },
                        [_vm._v("N/A")]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "largeText",
                          staticStyle: {
                            "font-size": "1.8rem",
                            "font-weight": "400"
                          }
                        },
                        [_vm._v("N/A")]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.new_costs, function(costs, index) {
                  return _vm.new_costs &&
                    _vm.enabledManufacturers[costs.manufacturer.id] === true
                    ? _c("fragment", { key: index }, [
                        _c("div", { staticClass: "offer" }, [
                          _c("strong", { staticClass: "offer-title red" }, [
                            _vm._v("Proposed Solution")
                          ]),
                          _vm._v(" "),
                          _vm.costsHasError(costs)
                            ? _c("div", { staticClass: "offer-errors" }, [
                                _c("img", {
                                  staticClass: "manufacturer-logo",
                                  attrs: {
                                    src:
                                      "/static/styles/mailkit/img/manu" +
                                      (costs.manufacturer.id - 1) +
                                      ".png"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "warning" }, [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "/static/styles/mailkit/img/warning.png"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", { staticClass: "red-text" }, [
                                      _vm._v(
                                        _vm._s(costs.manufacturer.name) +
                                          " option not available due to:"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    !costs.feeder_type_not_found &&
                                    costs.scale_cost_machine_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - " +
                                              _vm._s(
                                                _vm.additionalOptions.packets_capacity.replace(
                                                  "_",
                                                  " - "
                                                )
                                              ) +
                                              "kg scale size not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.departmental_accounting_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - " +
                                              _vm._s(
                                                _vm.additionalOptions
                                                  .accounts_amount
                                              ) +
                                              " accounts not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.postage_payment_arrears_warning
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Arrears postage account not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.differential_weighting_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Differential weighting is not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.business_mail_advanced_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Business mail advanced is not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.connectivity_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - " +
                                              _vm._s(
                                                _vm.additionalOptions
                                                  .connectivity
                                              ) +
                                              " connectivity option is not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.inbound_courier_parcel_tracking_cost_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Barcode scanner periphials are not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.outbound_shipping_application_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Outbound shipping application is not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.service_upgrade_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - Service upgrade is not available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.comparable_model_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - No comparable model available"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.feeder_type_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            " - " +
                                              _vm._s(
                                                _vm.getReadableFeederType(
                                                  _vm.additionalOptions
                                                    .feeder_type
                                                )
                                              ) +
                                              " not available;"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    costs.machine_not_found
                                      ? _c("div", { staticClass: "red-text" }, [
                                          _vm._v(
                                            "Can't find a machine that fits the requirements"
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "blue-text" }, [
                                  _vm._v(
                                    "If your requirements are flexible, try tailoring your options to pull more results"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.costsHasError(costs)
                            ? _c("table", { staticClass: "offer-table" }, [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "big",
                                      staticStyle: { width: "50%" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("manufacturer and model:")
                                      ]),
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "500" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer
                                                ? costs.printer.manufacturer
                                                    .name
                                                : ""
                                            ) +
                                              " " +
                                              _vm._s(
                                                costs.printer
                                                  ? costs.printer.model
                                                  : ""
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("th", { staticStyle: { width: "50%" } }, [
                                    _c("span", [_vm._v("Service offering")]),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticStyle: { "font-weight": "500" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            costs.printer
                                              ? costs.printer.service_name
                                              : "-"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", { staticClass: "image" }, [
                                    costs.printer
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm.printerImage(
                                              costs.printer.image_url
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", [
                                      _vm._v("Your potential savings")
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticStyle: {
                                        "white-space": "nowrap",
                                        "font-size": "1.8rem",
                                        "font-weight": "400",
                                        color: "#b50a78"
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          costs &&
                                            _vm.yourPotentialSavingIs(costs)
                                              .savings_over_term > 0
                                            ? _vm.mnwp(
                                                Math.abs(
                                                  _vm.yourPotentialSavingIs(
                                                    costs
                                                  ).savings_over_term
                                                )
                                              )
                                            : "N/A"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.costsHasError(costs)
                                      ? _c(
                                          "div",
                                          { staticClass: "offer-buttons" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "red",
                                                staticStyle: {
                                                  "font-size": "1.2rem",
                                                  margin: "0 10px",
                                                  padding: "7px 10px"
                                                },
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.toggleMoreInfo(
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("View Quote Details")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.costsHasError(costs)
                            ? _c("table", { staticClass: "offer-table" }, [
                                _c("tr", [
                                  _c("td", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "600",
                                          "text-align": "left",
                                          "padding-left": "10px"
                                        }
                                      },
                                      [_vm._v("Key machine specification:")]
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.costsHasError(costs)
                            ? _c("table", { staticClass: "offer-table" }, [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "25%",
                                        "border-top": "1px solid #ccc"
                                      }
                                    },
                                    [
                                      _vm._v("Speed"),
                                      _c("br"),
                                      _vm._v(" (letters/min)")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "25%",
                                        "border-top": "1px solid #ccc"
                                      }
                                    },
                                    [_vm._v("Envelope thickness")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "25%",
                                        "border-top": "1px solid #ccc"
                                      }
                                    },
                                    [_vm._v("Scale capacity")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "25%",
                                        "border-top": "1px solid #ccc",
                                        "border-right": "1px solid #ccc"
                                      }
                                    },
                                    [_vm._v("Product rating")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [
                                    _c("strong", [_vm._v("standard")]),
                                    _c("br"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          costs.printer
                                            ? costs.printer.speed_standard
                                            : 0
                                        ) +
                                        "\n\n                "
                                    ),
                                    _c("div", { staticClass: "separator" }),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v("Auto size"),
                                      _c("br"),
                                      _vm._v(" and weight")
                                    ]),
                                    _c("br"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          costs.printer
                                            ? costs.printer.auto_size_weight
                                            : 0
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        costs.printer
                                          ? costs.printer
                                              .envelope_thickness_capacity
                                          : 0
                                      ) + " mm"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        costs.printer
                                          ? costs.printer.scale_capacity
                                          : 0
                                      ) + " kg"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "border-right": "1px solid #ccc"
                                      }
                                    },
                                    [
                                      _c("rating-view", {
                                        attrs: {
                                          rating: costs.printer
                                            ? costs.rating
                                            : 0,
                                          max: _vm.results
                                            ? _vm.results.max_rating
                                            : 0
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.costsHasError(costs) &&
                          (costs.scale_cost_warning ||
                            costs.departmental_accounting_warning ||
                            costs.postage_recredit_costs_warning_for_pb ||
                            costs.scale_cost_machine_upgraded ||
                            costs.departmental_accounting_machine_upgraded)
                            ? _c("div", { staticClass: "offer-info-wrapper" }, [
                                costs.postage_recredit_costs_warning_for_pb
                                  ? _c("div", { staticClass: "offer-info" }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/styles/mailkit/img/warning.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "'Enhanced Service Level' not available on this option"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                costs.scale_cost_machine_upgraded
                                  ? _c("div", { staticClass: "offer-info" }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/styles/mailkit/img/warning-green.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "THIS MACHINE HAS BEEN UPGRADED TO ACCOMMODATE YOUR SCALE REQUIREMENT"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                costs.departmental_accounting_machine_upgraded
                                  ? _c("div", { staticClass: "offer-info" }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/styles/mailkit/img/warning-green.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "This machine has had to be upgraded to accommodate your departmental account requirements"
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        !_vm.costsHasError(costs) &&
                        _vm.showMoreInfo === index &&
                        costs.printer
                          ? _c(
                              "section",
                              { staticClass: "results more-info" },
                              [
                                _c("div", { staticClass: "results__table" }, [
                                  _c(
                                    "table",
                                    [
                                      _c("more-info-tr", {
                                        attrs: {
                                          quote: _vm.quote,
                                          new_costs: costs,
                                          current_costs: _vm.current_costs,
                                          model: costs.printer,
                                          service_upgrade:
                                            _vm.additionalOptions
                                              .service_upgrade,
                                          quote_confirmation:
                                            _vm.additionalOptions
                                              .quote_confirmation,
                                          additionalOptions:
                                            _vm.additionalOptions
                                        },
                                        on: {
                                          "progress-with-order": function(
                                            investment_option
                                          ) {
                                            return _vm.onProgressWithOrder(
                                              investment_option,
                                              _vm.quote,
                                              costs,
                                              _vm.additionalOptions,
                                              _vm.current_costs
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _vm._showDebug
        ? _c("quote-info", {
            attrs: {
              quote: _vm.quote,
              results: _vm.results,
              quote_confirmation: _vm.additionalOptions.quote_confirmation
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticStyle: { display: "block", padding: "15px 0" } }, [
        _vm._v("Lease Option 1")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticStyle: { display: "block", padding: "15px 0" } }, [
        _vm._v("Lease Option 2")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputmodal__close" }, [
      _c("img", { attrs: { src: "/static/styles/mailkit/img/multiply.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "noStyle" }),
      _vm._v(" "),
      _c("td", { staticClass: "locationRow", attrs: { colspan: "8" } }, [
        _c("div", [_c("h5", [_vm._v("Your Quote Options")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rotate blue", attrs: { rowspan: "1" } }, [
      _c("div", { staticStyle: { "font-size": "25px" } }, [_vm._v("Current")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", {
        staticStyle: { height: "10px", "background-color": "#F4F4F4" },
        attrs: { colspan: "9" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location" }, [
      _c("strong", [_vm._v("Your Quote Options")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "big" }, [_vm._v("Manufacturer and model")]),
      _vm._v(" "),
      _c("th", [_vm._v("Speed"), _c("br"), _vm._v(" (letters/min)")]),
      _vm._v(" "),
      _c("th", [_vm._v("Envelope thickness")]),
      _vm._v(" "),
      _c("th", [_vm._v("Standard scale capacity")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_vm._v("Auto size"), _c("br"), _vm._v(" and weight")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Service offering")]),
      _vm._v(" "),
      _c("th", [_vm._v("Product rating")]),
      _vm._v(" "),
      _c("th", [_vm._v("Your potential savings")]),
      _vm._v(" "),
      _c("th", [_vm._v("Features explained")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "contactCta" }, [
      _c("div", { staticClass: "in container" }, [
        _c("div", { staticClass: "contactCta__block" }, [
          _c("div", { staticClass: "in" }, [
            _c("h3", [
              _vm._v("Need to speak with us direct?\n            "),
              _c("br"),
              _vm._v("Call us today "),
              _c("a", { attrs: { href: "tel:0330 124 1977" } }, [
                _vm._v("0330 124 1977")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145cdd0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145cdd0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Results/Index.vue
// module id = null
// module chunks = 